import React from 'react';
import * as Sentry from '@sentry/browser';
import errorJson from 'static/json/error.json';
import locales from 'locales';
import Content from './partial/Content';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error) {
    return { hasError: true };
  }

  componentDidCatch(error) {
    Sentry.captureMessage(`${error.message} in ${window.location.href}`);
    Sentry.captureException({ error });
  }

  render() {
    if (this.state.hasError) {
      return (
        <Content
          image={errorJson}
          title={locales.pageErrorDescription}
          height={200}
          width={250}
        />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
